import { useRef, useState } from "react";
import moment from "moment";

export const useAllSaleList = (initialAllSales = [], ITEMS_PER_PAGE) => {
  const isFirstRender = useRef(true);
  const firstRender = isFirstRender.current;

  const initialData =
    firstRender && initialAllSales?.length
      ? initialAllSales.slice(0, ITEMS_PER_PAGE)
      : [];

  const [state, setState] = useState({
    isLoading: true,
    SaleList: initialData,
    totalPaid: 0,
    totalUnPaid: 0,
    totalSaleFilterCount: 0,
    totalSaleAmount: 0,
  });

  const getDateRange = (date) => {
    return {
      start: date?.startDate
        ? moment(date.startDate).startOf("day").valueOf()
        : undefined,
      end: date?.endDate
        ? moment(date.endDate).endOf("day").valueOf()
        : undefined,
    };
  };

  const calculateTotals = (data) => {
    let totals = {
      totalFilteredCount: data?.length || 0,
      totalPaid: 0,
      totalUnPaid: 0,
      totalSaleAmount: 0,
    };

    data.forEach((item) => {
      totals.totalSaleAmount += item.amount;

      if (item.status === "paid") {
        totals.totalPaid += item.amount;
      } else {
        totals.totalUnPaid += item.amount - (item.advance_amount || 0);
      }
    });
    return totals;
  };

  const handleAllSales = async ({
    business,
    filters,
    limit,
    offset,
    isCalculateTotal = true,
  }) => {
    const { date, amount,view, method, sort, status, keywords } =
      filters || {};

    setState((prev) => ({ ...prev, isLoading: true }));

    const { start, end } = getDateRange(date);

    try {
      let totals = {};

      // Calculate totals
      if (isCalculateTotal) {
        let rawData;

        if (firstRender) {
          rawData = initialAllSales;
        } else {
          const baseQuery = business.getAllSales(
            start,
            end,
            keywords || "",
            status,
            undefined,
            undefined,
            undefined,
            amount,
            view,
            method,
          );

          rawData = await baseQuery.unsafeFetchRaw();
        }

        totals = calculateTotals(rawData);
      }

      // Fetch paginated list
      const paginatedItems = firstRender
        ? initialData
        : await business
            .getAllSales(
              start,
              end,
              keywords || "",
              status,
              limit,
              offset,
              sort || "Newest",
              amount,
              view,
              method,
            )
            .fetch();

      const updatedList =
        offset > 0
          ? [...state.SaleList, ...paginatedItems]
          : paginatedItems;

      isFirstRender.current = false;

      setState((prev) => ({
        ...prev,
        isLoading: false,
        SaleList: updatedList,
        ...(isCalculateTotal && {
          totalPaid: totals.totalPaid,
          totalUnPaid: totals.totalUnPaid,
          totalSaleFilterCount: totals.totalFilteredCount,
          totalSaleAmount: totals.totalSaleAmount,
        }),
      }));
    } catch (error) {
      console.error(error);
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  return { ...state, handleAllSales };
};
